/*
 * Timeline: click-and-drag horizontal scrolling for non-touch devices.
 * Touch devices keep their native swipe (this only binds mouse events).
 */
(function () {
  var active = null;
  var startX = 0;
  var startScroll = 0;
  var moved = false;

  function onDown(e) {
    if (e.button !== 0) return; // primary button only
    active = e.currentTarget;
    moved = false;
    startX = e.pageX;
    startScroll = active.scrollLeft;
    active.classList.add('is-dragging');
  }

  function onMove(e) {
    if (!active) return;
    var dx = e.pageX - startX;
    if (Math.abs(dx) > 3) moved = true;
    active.scrollLeft = startScroll - dx;
  }

  function onUp() {
    if (!active) return;
    active.classList.remove('is-dragging');
    active = null;
  }

  function refresh(el) {
    // only advertise dragging (grab cursor) when the track actually overflows
    el.classList.toggle('is-draggable', el.scrollWidth > el.clientWidth + 1);
  }

  function init(root) {
    (root || document).querySelectorAll('.timeline-wrapper').forEach(function (el) {
      refresh(el);
      if (el.dataset.dragInit) return;
      el.dataset.dragInit = 'true';
      el.addEventListener('mousedown', onDown);
      el.addEventListener('dragstart', function (e) { e.preventDefault(); });
      // swallow the click that terminates a drag so it can't trigger a stray navigation
      el.addEventListener('click', function (e) {
        if (moved) { e.preventDefault(); e.stopPropagation(); }
      }, true);
    });
  }

  document.addEventListener('mousemove', onMove);
  document.addEventListener('mouseup', onUp);
  window.addEventListener('resize', function () {
    document.querySelectorAll('.timeline-wrapper').forEach(refresh);
  });

  if (document.readyState !== 'loading') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  }

  // Shopify theme editor: re-init when the section is reloaded
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
